<template>
  <div class="contact_list">
    <p class="no_content" v-if="list.length === 0">暂无内容</p>
    <ul>
      <li v-if="list.length > 0" class="pointer" v-for="item in list" :key="item.id">
        <p class="content_time"><img src="@/assets/clock-icon.png" /><span>发布日期 {{ item.createdAt | dateFormat }}</span></p>
        <p class="content_ask">{{ item.comment }}</p>
        <p class="content_answer">{{ item.reply }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'contactList',
  components: {},
  props: ['list'],
  data () {
    return {}
  },
  created () {
  },
  mounted () {
  },
  computed: {},
  methods: {},
  watch: {}
}
</script>

<style scoped>
  .contact_list { width: 680px; border-radius: 2px; padding: 10px 0; border: 1px solid #DCDFE6; }
  .contact_list ul li { padding: 10px 20px; }
  .contact_list ul li:hover { background-color: #F3F6F0; }
  .contact_list ul li .content_time { margin-bottom: 10px; }
  .contact_list ul li .content_time img { margin-right: 6px; width: 14px; height: 14px; }
  .contact_list ul li .content_time span { font-size: 12px; color: #999999; line-height: 12px; }
  .contact_list ul li .content_ask { color: #666666; font-size: 14px; font-weight: 600; line-height: 20px; margin-bottom: 5px; }
  .contact_list ul li .content_answer { color: #7FB842; font-size: 14px; line-height: 20px; }
</style>



// WEBPACK FOOTER //
// src/components/contact/list.vue